import React from 'react';

const GovImage = () => {
  return (
    <div className="py-20 bg-white grid min-h-[140px] w-full place-items-center  rounded-lg ">
      <img
        className="object-cover object-center w-1/2 max-w-none h-full"
        src="https://onedrive.live.com/embed?resid=38E489A2E9BE257B%2157266&authkey=%21AFjnYZWxYD1Ii2k&width=2500&height=2500"
        alt="Vg image"
      />
    </div>
  );
};

export default GovImage;
